var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-mobile",class:{
        'header-mobile--fixed': _vm.fixed,
        'header-mobile--transparent': _vm.transparent,
        'd-print-none': _vm.nonPrintable
    }},[_c('div',{staticClass:"header-mobile__left"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"header-mobile__center"},[_vm._t("center")],2),_vm._v(" "),_c('div',{staticClass:"header-mobile__right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }